require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./sex-offender-monitoring-and-compliance.json") })
        }
      }, "path---sex-offender-monitoring-and-compliance");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---sex-offender-monitoring-and-compliance!./.cache/json/sex-offender-monitoring-and-compliance.json
// module id = 978
// module chunks = 231608221292675